var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAdded = function SvgAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 57",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.653 56a6.534 6.534 0 01-4.636-1.948l-14.35-14.266-14.35 14.275a6.534 6.534 0 01-7.222 1.421A6.534 6.534 0 010 49.359V11.667A11.667 11.667 0 0111.667 0h28a11.667 11.667 0 0111.667 11.667v37.692a6.533 6.533 0 01-4.086 6.123 6.69 6.69 0 01-2.595.518z",
    fill: "currentColor"
  })));
};

export default SvgAdded;